(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ShiftTypeDialogController', ShiftTypeDialogController);

    ShiftTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ShiftType'];

    function ShiftTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ShiftType) {
        var vm = this;

        vm.shiftType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.shiftType.id !== null) {
                ShiftType.update(vm.shiftType, onSaveSuccess, onSaveError);
            } else {
                ShiftType.save(vm.shiftType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:shiftTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
